import { ServiceBundle } from '../../../../../models/service-bundle';
import { SaveServiceBundleForm } from './save-service-bundle.form';

interface CreateServiceBundleFormProps {
  unitID: number;
  onCompleted: (value: ServiceBundle) => void;
  refetch: () => void;
}

export const CreateServiceBundleForm = ({ unitID, onCompleted, refetch }: CreateServiceBundleFormProps) => {
  return <SaveServiceBundleForm unitID={unitID} onCompleted={onCompleted} refetch={refetch} />;
};
